// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._syazpsu8{color:var(--_vrm7dk)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-ui/dist/esm/MediaInlineCard/styled-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oBAAoB","sourcesContent":["._syazpsu8{color:var(--_vrm7dk)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
